import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";

interface SetupGuideState {
  step1Completed: boolean;
  step3Completed: boolean;
  toggleStep1: () => void;
  toggleStep3: () => void;
}

export const useSetupGuideStore = create<SetupGuideState>()(
  devtools(
    persist(
      (set) => ({
        step1Completed: false,
        step3Completed: false,
        toggleStep1: () =>
          set((state) => ({
            step1Completed: !state.step1Completed,
          })),
        toggleStep3: () =>
          set((state) => ({
            step3Completed: !state.step3Completed,
          })),
      }),
      {
        name: "setup-guide-storage",
      }
    ),
    { name: "SetupGuideStore" }
  )
);
